import { Button, Skeleton, Transfer } from 'antd';
import API from 'API';
import React, { useCallback, useEffect, useState } from 'react';
import { searchItem } from "general_function";
import FullMask from 'components/layout/FullMask';

export default function EnrollTeacher({ teacher }) {
    const [courses, setCourses] = useState(null);
    const [assignedCourses, setAssignedCourses] = useState(null);
    const [originalAssignedCourses, setOriginalAssignedCourses] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    useEffect(() => {
        async function getCourses() {
            try {
                const response = await API.get("/courses/", {params: {page_size: 1000}});
                setCourses(response.data.results.map(item=>({...item, key: String(item.id)})));
            } catch (e) {
                console.log(e);
            }
        }
        async function getAssignedCourses() {
            try {
                const response = await API.post("/enroll-course-teacher/", {teacher_id: teacher.id});
                const result = response.data.map(item=>String(item));
                setAssignedCourses(result);
                setOriginalAssignedCourses(result);
            } catch (e) {
                console.log(e);
            }
        }
        getCourses();
        getAssignedCourses();
    }, [teacher])

    const handleSave = useCallback(async ()=>{
        try {
            setSubmitting(true);
            const response = await API.post("/enroll-course-teacher/", {teacher_id: teacher.id, courses: assignedCourses});
            const result = response.data.map(item=>String(item));
            setAssignedCourses(result);
            setOriginalAssignedCourses(result);
        } catch (e) {
            console.log(e);
        } finally {
            setSubmitting(false);
        }
    },[assignedCourses, teacher])

    return courses === null || assignedCourses === null
        ? <Skeleton active />
        : <>
            {submitting && <FullMask page />}
            <Transfer
                titles={["Chưa đăng ký", "Đã đăng ký"]}
                dataSource={courses}
                targetKeys={assignedCourses}
                listStyle={{ width: "100%", height: 300 }}
                showSearch
                filterOption={(inputValue, option) => {
                    return searchItem(inputValue, option, ["name"])
                }}
                onChange={(newKeys) => {
                    setAssignedCourses(newKeys);
                }}
                render={item => item.name}
            />
            <div style={{ textAlign: 'center', marginTop: 5}}>
                <Button type='primary' onClick={handleSave}
                    disabled={originalAssignedCourses === assignedCourses}>Lưu</Button>
            </div>
        </>
}
